import fetchJSON from 'lib/fetchJSON'
import {Map} from 'immutable'
import {pending, fulfilled} from 'lib/promiseMiddlewareHelpers'
import _ from 'lodash'
import {deserializeGuidePage, serializeGuidePage} from 'lib/api/records'

export const LOAD_GUIDES = 'experiences_guides/LOAD_GUIDES'
export const UPDATE_GUIDE = 'experiences_guides/UPDATE_GUIDE'
export const CREATE_GUIDE = 'experiences_guides/CREATE_GUIDE'
export const DELETE_GUIDE = 'experiences_guides/DELETE_GUIDE'
export const REORDER_GUIDES = 'experiences_guides/REORDER_GUIDES'

const initialState = Map({
  'guidePages': Map({}), // guide page id -> GuidePage
  'experienceGuides': Map({}) // experience id -> [list of guide page ids, ordered]
})

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case fulfilled(LOAD_GUIDES):
      const {results} = action.payload

      const guideIds = _.map(_.sortBy(results, (r) => r.position), (g) => g.id)
      const guidePages = Map({}).withMutations(m => {
        _.each(results, (g) => { m.set(g.id, deserializeGuidePage(g)) })
      })

      return state.withMutations(s => {
        s.setIn(['guidePages'], guidePages)
        s.setIn(['experienceGuides', action.meta.experienceId], guideIds)
      })
    case fulfilled(UPDATE_GUIDE):
      const updatedGuide = deserializeGuidePage(action.payload.experience_guide_page)
      return state.mergeIn(['guidePages', updatedGuide.id], updatedGuide)
    case fulfilled(CREATE_GUIDE):
      const createdGuide = deserializeGuidePage(action.payload.experience_guide_page)

      const stateWithPage = state.setIn(['guidePages', createdGuide.id], createdGuide)

      // Update our page ordering
      const pageIds = stateWithPage.get('guidePages').valueSeq().sortBy(p => p.position).map((p) => p.id).toArray()

      return stateWithPage.setIn(['experienceGuides', createdGuide.experienceId], pageIds)
    case fulfilled(DELETE_GUIDE):
      const deletedGuide = action.meta.guide

      return state.withMutations(s => {
        s.deleteIn(['guidePages', deletedGuide.id])
        s.setIn(['experienceGuides', deletedGuide.experienceId], _.without(s.getIn(['experienceGuides', deletedGuide.experienceId]), deletedGuide.id))
      })
    case pending(REORDER_GUIDES):
      const reorderedIds = action.meta.guideIds
      return state.setIn(['experienceGuides', action.meta.experienceId], reorderedIds)
    default:
      return state
  }
}

export const loadGuides = (experienceId) => ({
  type: LOAD_GUIDES,
  payload: fetchJSON(`/experiences/${experienceId}/guide_pages.json?per_page=200`),
  meta: {experienceId}
})

export const updateGuidePage = (guide) => ({
  type: UPDATE_GUIDE,
  payload: fetchJSON(`/experience_guide_pages/${guide.id}.json`, {experience_guide_page: serializeGuidePage(guide)}, {method: 'PATCH'}),
  meta: {guide}
})

export const createGuidePage = (guide) => ({
  type: CREATE_GUIDE,
  payload: fetchJSON(`/experience_guide_pages.json`, {experience_id: guide.experienceId, experience_guide_page: serializeGuidePage(guide)}, {method: 'POST'}),
  meta: {guide}
})

export const deleteGuidePage = (guide) => ({
  type: DELETE_GUIDE,
  payload: fetchJSON(`/experience_guide_pages/${guide.id}.json`, {}, {method: 'DELETE'}),
  meta: {guide}
})

export const reorderGuidePages = (experienceId, guideIds) => ({
  type: REORDER_GUIDES,
  payload: fetchJSON(`/experience_guide_pages/reorder.json`, {experience_id: experienceId, order: serializeOrdering(guideIds)}, {method: 'POST'}),
  meta: {
    experienceId,
    guideIds
  }
})

const serializeOrdering = (guideIds) => {
  const ordering = {}
  guideIds.forEach((id, i) => { ordering[id] = i })
  return ordering
}
